<!--
* @description  参数1
* @fileName  detailEdit
* @author userName
* @date 2024-01-02 14:56:30
!-->
<template>
	<div id="detailEdit" class="detailEdit">
		<DialogEidt :value="isShow" @close="closeDialog">
			<template v-slot:title>
				<div>Detail edit</div>
			</template>
			<template v-slot:body>
				<div class="main-info p24 check-price-form">
					<el-form :model="formData" :rules="allRules" ref="formData" label-position="top" size="medium"
						@submit.native.prevent class="item-Surcharge">
						<div class="new_inquiry_header item-Surcharge_search">
							<el-form-item class="flex-width_1" prop="realName" label="Name">
								<el-input v-model="formData.realName"></el-input>
							</el-form-item>
							<el-form-item class="flex-width_1" prop="customerName" label="Company name">
								<el-input v-model="formData.customerName" disabled></el-input>
							</el-form-item>
							<el-form-item class="flex-width_1" prop="mobilePhone" label="Phone number">
								<el-input v-model="formData.mobilePhone"></el-input>
							</el-form-item>
						</div>
					</el-form>
				</div>
			</template>
			<template v-slot:footer>
				<div class="foot-class">
					<button class="cancel" @click="closeDialog">Cancel</button>
					<button class="save by-button--primary" @click="clickSave" :loading="btnLoading">Save</button>
				</div>
			</template>
		</DialogEidt>
	</div>
</template>

<script>
	import DialogEidt from "../../../components/Dialog/Dialog.vue";
	import request from '@/utils/request'
	import {
		getCookie
	} from '@/utils/cookiejs'
	export default {
		props: {
			// 父辈向子辈传参
			isShow: {
				type: Boolean,
				default: () => {
					return false;
				},
			},
		},
		name: "detailEdit",
		data() {
			var checkEmpty = (rule, value, callback) => {
				if (rule.required === false) {
					callback();
					return false;
				}
				if (!value) {
					if (rule.fullField == "StartCityKey") {
						console.log("====isCol1", rule, value, callback, this);
						this.isCol1 = true;
					} else {
						this.isCol1 = false;
					}

					document.documentElement.scrollTop = 0;
					return callback(new Error("Please enter name"));
				} else {
					callback();
				}
			};
			return {
				formData: {
					id: "",
					realName: "",
					customerName: "",
					mobilePhone: "",
				},
				token: "",
				btnLoading: false,
				allRules: {
					realName: [{
							required: true,
							validator: checkEmpty,
							trigger: "change"
						},
						{
							pattern: /^.{3,}$/,
							message: "Full name is required.",
							trigger: 'blur'
						},
					],
					customerName: [{
						required: true,
						trigger: "blur",
						message: "login.passwordTip"
					}, ],
					mobilePhone: [{
						pattern: /^(\+)([0-9]{1,3})(\s)([0-9]{3,11})$/,
						message: "Please enter a valid mobile phone number.",
						trigger: "blur",
					}],
				},
			};
		},
		created() {
			// 实例被创建之后执行代码
			this.token = getCookie('token')
			if (this.token) {
				this.getCustomerInfo()
			}
		},
		computed: {
			// 计算属性
		},
		components: {
			// 组件的引用
			DialogEidt,
		},
		methods: {
			// 方法
			getCustomerInfo() {
				request({
					url: `/api/crm/Customer/GetCurrCustomer`,
					method: 'GET',
					headers: {
						Authorization: this.token
					},
				}).then(res => {
					if (res.data != null) {
						this.formData.id = res.data.id
						this.formData.realName = res.data.firstName + " " + res.data.lastName;
						this.formData.customerName = res.data.customerName
						this.formData.mobilePhone = res.data.mobilePhone
					}
				})
			},
			closeDialog() {
				this.$emit("close", false);
			},
			clickSave() {
				//表单校验
				this.$refs["formData"].validate((val) => {
					console.log("====校验", val);
					if (val) {
						request({
							url: '/api/crm/Customer/Personal/' + this.formData.id,
							method: 'PUT',
							data: this.formData,
							headers: {
								Authorization: this.token
							},
						}).then((res) => {
							this.$message({
								message: res.msg,
								type: 'success',
								duration: 1000,
								onClose: () => {
									this.btnLoading = false;
									this.closeDialog()
									this.$emit('refresh', true)
								}
							})
						}).finally(() => {
							this.btnLoading = false;
						})
					}
				})
			},
		},
		mounted() {
			// 页面进入时加载内容
		},
		watch: {
			// 监测变化
		},
	};
</script>
<style scoped lang='scss'>
	::v-deep .dialog__header {
		text-align: left;
	}

	::v-deep .dialog__body {
		padding: 0;

		.el-form-item {
			margin-bottom: 0;

			.el-form-item__label {
				float: left;
			}
		}
	}

	::v-deep .el-form-item__error {
		display: block !important;
	}

	.foot-class {
		margin: 24px 0;
		padding-bottom: 24px;
		text-align: right;

		.cancel {
			width: 72px;
			height: 32px;
			background: #ffffff;
			border-radius: 4px;
			border: 1px solid #dddddd;
			font-size: 14px;
			font-family: PingFangSC, PingFang SC;
			font-weight: 500;
			color: #333333;
			margin-right: 16px;
			cursor: pointer;
		}

		.save {
			width: 72px;
			height: 32px;
			border-radius: 4px;
			cursor: pointer;
		}
	}
</style>